import Model from '@/models/Model'
import ParagraphModel from './ParagraphModel'

export default class GeologicTypeModel extends Model {
  constructor (data, included = null) {
    super(data, included)
  }

  get name () {
    return this.get('attributes.name') || this.get('name') || 'NO NAME'
  }

  get paragraphs () {
    const ps = this.get('rel.paragraph_content')
    if (ps) return ps.map((p) => { return new ParagraphModel(p, this._included) })
    return null
  }
}
